import { render } from "./PromotionForm.vue?vue&type=template&id=00eda09a&scoped=true&ts=true"
import script from "./PromotionForm.vue?vue&type=script&lang=ts"
export * from "./PromotionForm.vue?vue&type=script&lang=ts"

import "./PromotionForm.vue?vue&type=style&index=0&id=00eda09a&scoped=true&lang=css"
import "./PromotionForm.vue?vue&type=style&index=1&id=00eda09a&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00eda09a"]])

export default __exports__